import type { ComponentType } from "react";

import { cn } from "../../utils/styling";
import { MyMap as MyMapBase } from "../map/Map";

const MyMap = MyMapBase as ComponentType<any>;

type AssetMiniMapProps = {
  className?: string;
  latitude: number;
  longitude: number;
};

export const AssetMiniMap = ({ className, latitude, longitude }: AssetMiniMapProps) => {
  const data = [
    { center: [latitude, longitude], color: "var(--color-purpose-status-negative-subtle)", latitude, longitude },
  ];

  return (
    <MyMap
      className={cn("h-96 w-full", className)}
      data={data}
      defaultLayer="Standard"
      hasTooltip={false}
      rerenderVariable={[]}
      resizeTriggerVariables={[]}
      style={{
        height: "40rem",
      }}
    />
  );
};
